import { useSamplesSurfaceMicrobialBaseDataCreateMutation } from "@/services/backend/samples/api/surface-microbial-base-data-api";
import { CreateSampleBaseDataDialog } from "@/services/backend/samples/components/create-sample-base-data-dialog";

export function CreateSurfaceMicrobialBaseDataDialog() {
  const mutation = useSamplesSurfaceMicrobialBaseDataCreateMutation();
  return <CreateSampleBaseDataDialog mutation={mutation} />;
}
